import { vuetifyTranslations } from "@/application/plugins/i18n";
import { aliases, lucideIcons } from "@/application/plugins/icons";
import { createVuetify, VuetifyOptions } from "vuetify";

import "@/styles/main.scss";
import "vuetify/styles";

import "@fontsource/plus-jakarta-sans/300.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";

const config: VuetifyOptions = {
  locale: {
    locale: "nl",
    messages: vuetifyTranslations,
  },
  icons: {
    defaultSet: "lucideIcons",
    sets: { lucideIcons },
    aliases,
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#2563EB",
          "on-primary": "#FFFFFF",

          accent: "#1D4ED8",
          "on-accent": "#FFFFFF",

          secondary: "#EFF6FF",
          "on-secondary": "#1E3A8A",

          "stepper-surface": "#DBEAFE",
          "on-stepper-surface": "#1D4ED8",

          "surface-1": "#F8FAFC",
          emphasis: "#64748B",
          "font-color": "#0F172A",
          border: "#CBD5E1",

          error: "#DC2626",
          success: "#16A34A",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      rounded: "pill",
      elevation: 0,
    },
    VCard: {
      rounded: "lg",
      elevation: 0,
    },
    VTextField: {
      rounded: "lg",
      height: 56,
      variant: "solo",
    },
    VSelect: {
      rounded: "lg",
      height: 56,
      variant: "solo",
    },
    VAutocomplete: {
      rounded: "lg",
      variant: "solo",
      autocomplete: "suppress",
    },
    VTextarea: {
      rounded: "lg",
      rows: 2,
      variant: "solo",
    },
    VAlert: {
      rounded: "lg",
    },
    VSwitch: {
      inset: true,
      color: "primary",
      hideDetails: true,
    },
  },
};

export default createVuetify(config);
